import { SettingConst } from '@faire/web-api--source/types';

/**
 * Test improvements to the discover page:
 * PRD: https://www.notion.so/faire/Discover-Page-Redesign-Phase-4-What-is-Faire-5f83fca55f034d88bafccaf572836926?pvs=4
 */
export const PHASE_4_DISCOVER_PAGE_IMPROVEMENTS_120224 =
  'PHASE_4_DISCOVER_PAGE_IMPROVEMENTS_120224' as SettingConst<
    'PHASE_4_DISCOVER_PAGE_IMPROVEMENTS_120224',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
